
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import BootboxService from '../../services/BootboxService'
interface IFormInput {
  caseId: string;
  serialNumber: string;
}

const schema = yup.object({
  caseId: yup
    .string()
    .matches(/^[0-9]+$/, 'Invalid Case ID. Only numbers are allowed')
    .required('Case ID is required'),
  serialNumber: yup
    .string()
    .matches(/^[a-zA-Z0-9]+$/, 'Invalid Serial Number. Only alphanumeric characters are allowed')
    .required('Serial number is required')

})

const BootboxForm = () => {
  const { bootbox } = useParams<{ bootbox: string }>()
  const bootboxService: BootboxService = new BootboxService()
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<IFormInput>({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    bootboxService.getBootbox(bootbox)
      .then((response: any) => {
        if (!response.success) {
          history.push('/404')
        }
      })
  }, [bootbox])

  const onSubmit = async (values: IFormInput) => {
    setLoading(true)
    const response = await bootboxService.checkinBootbox(bootbox, values.serialNumber, values.caseId)
    if (response.success) {
      toast.success('Bootbox checked in successfully!')
      reset()
    } else {
      toast.error(response.error)
    }
    setLoading(false)
  }

  return (
        <div className="flex flex-col items-center bg-white py-16 px-24 rounded-xl m-auto">
            <img src="/icons/bootvision-logo-black.svg" alt="Logo" className="w-44 mb-8" />
            <h1 className="font-semibold mb-2 self-start">Bootbox Check In</h1>
            {!bootbox && (<p className="text-red-500 text-xs">Bootbox id required, try scanning the QR code again!</p>)}
            <form onSubmit={handleSubmit(onSubmit)} className="w-96 flex flex-col gap-4 mt-4">
                <label className="text-xs text-gray-400 font-semibold">
                    Boot Serial Number
                    <input
                        {...register('serialNumber')}
                        placeholder='Type in the boot serial number...'
                        required
                        className="w-full h-10 px-2 py-1 mt-2 text-black bg-gray-200 rounded text-sm"
                    />
                    {errors.serialNumber && (<p className="text-red-500 text-xs">{errors.serialNumber.message}</p>)}
                </label>
                <label className="text-xs text-gray-400 font-semibold">
                    Case Number
                    <input
                        {...register('caseId')}
                        placeholder='Type in the case number...'
                        required
                        type="text"
                        className="w-full h-10 px-2 py-1 mt-2 text-black bg-gray-200 rounded text-sm"
                    />
                    {errors.caseId && (<p className="text-red-500 text-xs">{errors.caseId.message}</p>)}
                </label>
                <button type="submit" disabled={loading} className={`w-full h-10 font-semibold py-2 ${!loading ? 'bg-emerald-500' : 'bg-gray-500'} text-white text-sm rounded-xl mt-6`}>{loading ? 'Loading' : 'Submit'}</button>
            </form>
            <ToastContainer/>
        </div>
  )
}

export default BootboxForm
